module.exports = __webpack_public_path__ + "img/marinas.c6094646.png";